<script setup>
import { computed } from 'vue'
import {
  KkModal,
  KkButton,
} from '../../../../components/base'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import { dayOfWeek } from '../../../../modules/dayOfWeekConst'
import iconInstagramPath from '../../../../../../images/sns/icon_instagram.svg'
import iconFacebookPath from '../../../../../../images/sns/icon_facebook.svg'
import iconTwitterPath from '../../../../../../images/sns/icon_x.svg'

const { t } = useI18n()

const emit = defineEmits(['close'])
const props = defineProps({
  targets: { type: Array, required: true },
  scheduledAt: { type: Date, required: false },
  status: { type: String, default: '' },
  openModal: { type: Boolean, default: false }
})

const snsImage = (type) => {
  switch (type) {
  case 'facebook':
    return iconFacebookPath
  case 'instagram':
    return iconInstagramPath
  case 'twitter':
    return iconTwitterPath
  }
}

const dayOfWeekOfReservationDate = computed(() => {
  const dowNumber = moment(props.scheduledAt).day()
  return Object.values(dayOfWeek)[dowNumber]
})
const publishedDateTime = (publishedAt) => {
  if (!publishedAt && !props.scheduledAt) return '-'

  if (props.status === 'progress') {
    if (!publishedAt) return t('pages.CompaniesStoreSnsPost.index.accountModal.processing')
  }

  const dateTime = publishedAt ? publishedAt : props.scheduledAt
  const dayOfWeek = dayOfWeekOfReservationDate.value.charAt(0)
  return moment(dateTime).format(`${t('format.date.default')}(${dayOfWeek}) ${t('format.time.default')}`)
}

</script>
<template>
  <KkModal :is-visible="props.openModal" @change="emit('close')">
    <div class="content__header">
      {{ t('pages.CompaniesStoreSnsPost.index.accountModal.title') }}
    </div>
    <div class="content__body">
      <div v-for="(target, index) in props.targets" :key="index" class="accountContainer">
        <div class="accountContainer__images">
          <img alt="" :src="target.account.picture.url" class="accountContainer__thumbnail">
          <img alt="" :src="snsImage(target.kind)" class="accountContainer__icon">
        </div>
        <div class="accountContainer__contents">
          {{ target.account.name }}
          <div class="accountContainer__pageId">@{{ target.account.username }}</div>
        </div>
        <div v-if="Object.keys(target.syncErrors).length" class="accountContainer__error">
          {{ t('pages.CompaniesStoreSnsPost.index.accountModal.error') }}
        </div>
        <div v-else class="accountContainer__processing">
          {{ publishedDateTime(target.publishedAt) }}
        </div>
      </div>
    </div>
    <div class="content__footer">
      <div class="c-button">
        <div class="buttonItem">
          <KkButton
            color="secondary"
            outlined
            :text="t('labels.close')"
            @click="emit('close')"
          />
        </div>
      </div>
    </div>
  </KkModal>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }

  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }

  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
.accountContainer {
  display: flex;
  align-items: center;
  padding: 18px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  margin: 10px 0;
  &__images {
    position: relative;
    margin-right: 30px;
    img{
      border-radius: 50%;
    }
  }
  &__thumbnail {
    width: 50px;
    height: 50px;
    object-fit: cover;
  }
  &__icon {
    position: absolute;
    width: 32px;
    height: 32px;
    bottom: 0;
    left: 60%;
    background: #fff;
    border: solid 3px #fff;
  }
  &__pageId {
    color: #9e9e9e;
  }
  &__error {
    margin-left: auto;
    color: $color-accent-primary;
  }
  &__postedAt {
    margin-left: auto;
  }
  &__processing {
    margin-left: auto;
  }
}
.buttonItem {
  margin-left: 10px;
}
</style>
